/* eslint-disable no-console */

const csrfToken = () => document.querySelector('meta[name="csrf-token"]').content;

export const updateChatkitConversation = async (chatkitThreadId, flowType) => {
  try {
    const res = await fetch('/ai/chatkit_conversation', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
      body: JSON.stringify({ open_ai_chatkit_thread_id: chatkitThreadId, flow_type: flowType })
    });
    if (!res.ok) throw new Error();
    return res.ok;
  } catch (error) {
    console.error('Error updating chatkit conversation:', error);
    return false;
  }
};

export const fetchToken = async (chatkitThreadId, context = {}) => {
  try {
    const body = {
      ...(chatkitThreadId ? { open_ai_chatkit_thread_id: chatkitThreadId } : {}),
      ...(Object.keys(context).length > 0 ? { context } : {})
    };
    const res = await fetch('/ai/chatkit_tokens', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error();
    const data = await res.json();
    return { token: data.token, flowType: data.flow_type };
  } catch (error) {
    console.error('Error fetching ChatKit token:', error);
    return null;
  }
};
